namespace Portico.Models.Enterprise {
    import psge = apigateway.enums;
    import psgm = apigateway.models;

    export interface IWebAddress {
        id: number;
        type: number | string;
        url: string;
    }

    export class WebAddress implements IWebAddress {
        id: number;
        type: number | string;
        url: string;

        constructor(obj?: IWebAddress | any) {
            this.id = null;
            this.type = null;
            this.url = '';

            if (obj) {
				this.id = obj.id || obj.webAddressId || null;
				this.type = obj.type || obj.webAddressType || null;
                this.url = obj.url || '';
            }
        }

        mapToEnterpriseCoordinatorWebAddress() : psgm.EnterpriseCoordinatorSharedWebAddressUpsearchModel {
            return {
                webAddressId: this.id,
                webAddressType: psge.ContactInfoPurposeType[this.type],
                url: this.url
            } as psgm.EnterpriseCoordinatorSharedWebAddressUpsearchModel
        }
    }
}
